import { setErrorReporter } from 'jcsdk';

/**
 * Installs the app's error reporter. Today it logs to the console; this is the
 * single seam where a real backend (e.g. Sentry's `captureException`) plugs in.
 * Called once at startup, before render. Error boundaries and the data layer
 * route through {@link reportError}, so wiring lives here alone.
 */
export const installHoopsErrorReporter = (): void => {
    setErrorReporter((error, context) => {
        console.error('[hoops]', error, context ?? {});
        // Sentry.captureException(error, { extra: context });
    });
};
